import { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

const MONTHS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

// Year range: 2025 is the hard floor; the upper bound auto-expands as
// the calendar year advances (current year + 2 for forward planning).
const MIN_YEAR = 2025;
const currentYear = new Date().getFullYear();
const maxYear = Math.max(currentYear + 2, MIN_YEAR);
const YEARS = Array.from({ length: maxYear - MIN_YEAR + 1 }, (_, i) => String(MIN_YEAR + i));

const MonthPicker = ({ value, onChange, testId }) => {
  const parsedMonth = value ? value.split("-")[1] || "" : "";
  const parsedYear = value ? value.split("-")[0] || "" : "";

  const [month, setMonth] = useState(parsedMonth);
  const [year, setYear] = useState(parsedYear);

  useEffect(() => {
    setMonth(value ? value.split("-")[1] || "" : "");
    setYear(value ? value.split("-")[0] || "" : "");
  }, [value]);

  const handleMonthChange = (val) => {
    setMonth(val);
    if (val && year) {
      onChange(`${year}-${val}`);
    }
  };

  const handleYearChange = (val) => {
    setYear(val);
    if (month && val) {
      onChange(`${val}-${month}`);
    }
  };

  return (
    <div style={{ display: "flex", gap: "0.5rem" }} data-testid={testId}>
      <div style={{ flex: 2 }}>
        <Select value={month || undefined} onValueChange={handleMonthChange}>
          <SelectTrigger
            className="form-input"
            style={{ height: "auto", padding: "0.6rem 0.75rem", border: "1px solid rgba(96, 240, 248, 0.2)", background: "rgba(10, 18, 42, 0.8)", color: month ? "var(--octopus-ice)" : "var(--octopus-voltage)" }}
            data-testid={testId ? `${testId}-month` : undefined}
          >
            <SelectValue placeholder="Month..." />
          </SelectTrigger>
          <SelectContent
            style={{ background: "rgba(10, 18, 42, 0.98)", border: "1px solid rgba(96, 240, 248, 0.2)", backdropFilter: "blur(12px)" }}
          >
            {MONTHS.map((m) => (
              <SelectItem
                key={m.value}
                value={m.value}
                style={{ color: "var(--octopus-ice)", cursor: "pointer" }}
              >
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div style={{ flex: 1 }}>
        <Select value={year || undefined} onValueChange={handleYearChange}>
          <SelectTrigger
            className="form-input"
            style={{ height: "auto", padding: "0.6rem 0.75rem", border: "1px solid rgba(96, 240, 248, 0.2)", background: "rgba(10, 18, 42, 0.8)", color: year ? "var(--octopus-ice)" : "var(--octopus-voltage)" }}
            data-testid={testId ? `${testId}-year` : undefined}
          >
            <SelectValue placeholder="Year..." />
          </SelectTrigger>
          <SelectContent
            style={{ background: "rgba(10, 18, 42, 0.98)", border: "1px solid rgba(96, 240, 248, 0.2)", backdropFilter: "blur(12px)" }}
          >
            {YEARS.map((y) => (
              <SelectItem
                key={y}
                value={y}
                style={{ color: "var(--octopus-ice)", cursor: "pointer" }}
              >
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default MonthPicker;
